import React, { useState } from "react";



const VerifyCertificate = () => {
  const [certId, setCertId] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!certId.trim()) return;
    // Plug your real verification logic here (API call, redirect, etc.)
    setSubmitting(true);
    setTimeout(() => {
      setSubmitting(false);
      // For now just log – replace with actual result handling
      console.log("Verifying certificate:", certId);
    }, 800);
  };

  return (
    <main className="min-h-screen bg-slate-50 text-slate-900">
      {/* HERO */}
      <section className="relative overflow-hidden bg-[#020819] text-white">
        {/* soft overlays */}
        <div className="pointer-events-none absolute inset-0 opacity-[0.25]">
          <img
            src="/new_img/rooftop-fall.png"
            alt="Rooftop fall protection"
            className="h-full w-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/70 to-black/40" />
        <div className="absolute inset-0 opacity-[0.2] [background-image:linear-gradient(to_right,#1e293b_1px,transparent_1px),linear-gradient(to_bottom,#1e293b_1px,transparent_1px)] [background-size:46px_46px]" />

        <div className="relative mx-auto flex max-w-6xl flex-col gap-4 px-6 pt-24 pb-16 md:pt-28 md:pb-20">
          <p className="text-[11px] uppercase tracking-[0.32em] text-slate-300">
            Training &amp; Inspection Records
          </p>
          <h1 className="text-3xl font-semibold md:text-4xl lg:text-[2.7rem]">
            Certificate Verification
          </h1>
          <p className="max-w-xl text-sm text-slate-200 md:text-[0.96rem]">
            Quickly verify the authenticity and status of inspection or training
            certificates issued through Scaftech-approved systems. Enter a
            certificate ID to confirm validity and basic details.
          </p>
        </div>
      </section>

      {/* BODY */}
      <section className="py-10 md:py-14">
        <div className="mx-auto flex max-w-6xl flex-col gap-10 px-6 lg:flex-row">
          {/* Left: copy / explanation */}
          <div className="flex-1 space-y-5">
            <h2 className="text-xl font-semibold text-slate-900 md:text-2xl">
              Why certificate verification matters
            </h2>
            <p className="text-sm leading-relaxed text-slate-600 md:text-[0.95rem]">
              Certificate verification helps ensure that equipment, lifting
              operations, and personnel training records are:
            </p>
            <ul className="ml-5 list-disc space-y-2 text-sm text-slate-600 md:text-[0.95rem]">
              <li>Issued by an authorized and recognized body.</li>
              <li>Valid for the specified period and scope.</li>
              <li>Matched correctly to the equipment or personnel ID.</li>
              <li>
                Available for audit, compliance checks, and regulatory review.
              </li>
            </ul>
            <p className="pt-2 text-sm text-slate-600 md:text-[0.95rem]">
              For complex cases or bulk verifications, please contact our team
              using the main contact channels so we can assist with structured
              validation support.
            </p>

            <div className="mt-4 rounded-2xl border border-dashed border-slate-300 bg-slate-100 p-4 text-[13px] text-slate-700">
              <p className="font-semibold text-slate-900">
                Need help with a certificate?
              </p>
              <p className="mt-1">
                If a certificate ID cannot be verified or returns unexpected
                results, kindly reach out via{" "}
                <a
                  href="mailto:consult@scaftechservices.com"
                  className="font-semibold text-[#062b6c] underline-offset-2 hover:underline"
                >
                  consult@scaftechservices.com
                </a>{" "}
                with a copy of the document in question.
              </p>
            </div>
          </div>

          {/* Right: verification card */}
          <div className="flex-1">
            <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm md:p-7">
              <p className="text-[11px] uppercase tracking-[0.26em] text-slate-500">
                Verify a certificate
              </p>
              <h3 className="mt-2 text-lg font-semibold text-slate-900 md:text-xl">
                Enter certificate ID
              </h3>
              <p className="mt-2 text-sm text-slate-600 md:text-[0.95rem]">
                Paste the certificate or equipment ID exactly as it appears on
                the document. The system will attempt to match it against our
                verification records.
              </p>

              <form
                className="mt-6 space-y-4"
                onSubmit={handleSubmit}
                noValidate
              >
                <div className="flex flex-col gap-2">
                  <label
                    htmlFor="certId"
                    className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-700"
                  >
                    Certificate ID
                  </label>
                  <input
                    type="text"
                    id="certId"
                    value={certId}
                    onChange={(e) => setCertId(e.target.value)}
                    placeholder=""
                    className="w-full rounded-xl border border-slate-300 bg-white px-3 py-3 text-sm text-slate-900 outline-none transition focus:border-[#062b6c] focus:ring-1 focus:ring-[#062b6c]"
                  />
                </div>

                <button
                  type="submit"
                  disabled={submitting || !certId.trim()}
                  className="inline-flex w-full items-center justify-center rounded-full bg-[#062b6c] px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[#03112f] disabled:cursor-not-allowed disabled:opacity-70"
                >
                  {submitting ? "Checking..." : "Search"}
                </button>
              </form>

              <p className="mt-4 text-[11px] text-slate-500">
                By using this tool, you confirm that you are authorized to view
                the associated certification details and will handle any
                retrieved information in line with applicable data protection
                and compliance requirements.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default VerifyCertificate;
